/* Phone sticky Add to Bag (the theme's own .fixedDummyATC and quick-shop panel, printed by every shto buy box: see sections/shto-product-buy.liquid). The theme's CSS shows it on
   phones while <body> has with-fixed-product-atc; its own scroll script only sets that on the old #singleProduct layout. Here the
   class is on while neither the hero nor the buy box is on screen, like the live page, where it appears once the buy box
   (at the top there) is scrolled past. Tapping it opens the theme's quick-shop panel (theme-scripts.js). */
(function () {
  if (window.shtoStickyAtc) return;
  window.shtoStickyAtc = true;
  function start() {
    if (!document.querySelector('[data-shto-sticky-atc]') || document.getElementById('singleProduct') || !('IntersectionObserver' in window)) return;
    // The page's hero and buy box: Blood Flow's by id, other pages' by the data-shto-hero / data-shto-buybox markers.
    var watched = Array.prototype.slice.call(document.querySelectorAll('#shto-hero, [data-shto-hero], #shto-product-buy, [data-shto-buybox]'));
    if (!watched.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.shtoOnScreen = e.isIntersecting; });
      var show = watched.every(function (el) { return !el.shtoOnScreen; });
      document.body.classList.toggle('with-fixed-product-atc', show);
    });
    watched.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
